import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { colors, fontSize } from 'styles/cp';

interface BatchInvoiceHeaderTitleProps {
  invoicesCount: number;
  dueTotalAmount: number;
  overDueTotalAmount: number;
  currency: string;
}

const MAX_INVOICES_COUNT_DISPLAY = 100;

const BatchInvoiceHeaderTitle = ({
  invoicesCount,
  dueTotalAmount,
  overDueTotalAmount,
  currency,
}: BatchInvoiceHeaderTitleProps) => {
  return (
    <div className="header-title">
      <span className="header-title-text">
        {invoicesCount < MAX_INVOICES_COUNT_DISPLAY ? (
          <FormattedMessage
            id="UNPAID_INVOICES"
            defaultMessage="Unpaid invoices ({count})"
            values={{ count: invoicesCount }}
          />
        ) : (
          <FormattedMessage id="UNPAID_INVOICES_PLURAL" defaultMessage="Unpaid invoices (100+)" />
        )}
      </span>
      <div className="header-title-amounts">
        {dueTotalAmount > 0 && (
          <>
            <span className="header-title-due-amount">
              <FormattedNumber value={dueTotalAmount} style="currency" currency={currency} /> due
            </span>
          </>
        )}
        {dueTotalAmount > 0 && overDueTotalAmount > 0 && (
          <span className="header-title-separator"> · </span>
        )}
        {overDueTotalAmount > 0 && (
          <>
            <span className="header-title-overdue-amount">
              <FormattedNumber value={overDueTotalAmount} style="currency" currency={currency} />{' '}
              overdue
            </span>
          </>
        )}
      </div>
      <style jsx>{`
        .header-title {
          font-family: AvenirNextforINTUIT-Demi;
          font-size: ${fontSize.sm};
          color: ${colors.gray};
          margin-bottom: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .header-title-amounts {
          display: flex;
          align-items: center;
          gap: 4px;
          font-family: AvenirNextforINTUIT-Regular;
        }

        .header-title-due-amount,
        .header-title-overdue-amount {
          font-size: ${fontSize.xs};
          color: ${colors.gray02};
        }

        .header-title-separator {
          color: ${colors.gray02};
        }
      `}</style>
    </div>
  );
};

export default BatchInvoiceHeaderTitle;
